export default __webpack_public_path__ + "static/media/mp.f4332866.svg";